import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { ar } from './ar';
import { en } from './en';

export type Language = 'ar' | 'en';
const STORAGE_KEY = 'fs_language';

function storedLanguage(): Language {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'en' ? 'en' : 'ar';
  } catch {
    return 'ar';
  }
}

export function applyDocumentDirection(language: Language): void {
  document.documentElement.lang = language;
  document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
}

export function setLanguage(language: Language): void {
  void i18n.changeLanguage(language);
  applyDocumentDirection(language);
  try {
    localStorage.setItem(STORAGE_KEY, language);
  } catch {
    // Language preference is a convenience only.
  }
}

const initial = storedLanguage();
void i18n.use(initReactI18next).init({
  resources: { ar: { translation: ar }, en: { translation: en } },
  lng: initial,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  returnNull: false,
});
applyDocumentDirection(initial);

export { REASON_GROUPS, type ReasonGroup, reasonText, useReasonText } from './reason-text';
export { useErrorMessage } from './use-error-message';
export { useFieldIssues } from './use-field-issues';
export default i18n;
